<template>
  <FormProvider
    :key="formProviderRemountKey"
    :slot-id="data.id"
    :registry-form-id="dialogRegistryFormId"
    :window-instance-id="data.id"
    :session-id="data.sessionId"
  >
    <DialogWrapper
      :data="data"
      :title="pageTitle"
      @close="handleClose"
    />
  </FormProvider>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { resolveDialogSlotRegistryFormId, resolveDialogSlotSchemaRemountKey } from '@/common/utils/sameWindowFormRefetch'
import { useAppStore } from '@/stores/app'
import { getFormTitle } from '@/common/utils/formTitle'
import FormProvider from '@/components/platform/FormProvider.vue'
import DialogWrapper from './DialogWrapper.vue'
import { SAME_WINDOW_REPLACE_EVENT } from '@/common/utils/createWindowSlotId'

interface Props {
  data: {
    id: string
    sessionId: string
    config?: any
  }
}

const props = defineProps<Props>()
const appStore = useAppStore()
const remountGen = ref(0)

const formProviderRemountKey = computed(() =>
  resolveDialogSlotSchemaRemountKey(
    pageData.value as Record<string, unknown> | null,
    props.data.id,
    remountGen.value,
  ),
)

const pageData = computed(() => {
  const data = appStore.pagesData[props.data.id]
  return data ?? null
})

const dialogRegistryFormId = computed(() => {
  return resolveDialogSlotRegistryFormId(
    pageData.value as Record<string, unknown> | null,
    props.data.id,
    appStore.dialogs?.[props.data.id]?.fid,
  )
})

const pageTitle = computed(() => {
  return getFormTitle(pageData.value)
})

const handleClose = () => {
  // Закрытие будет обработано в DialogWrapper
}

const onSameWindowReplace = (event: Event) => {
  const slotId = (event as CustomEvent<{ slotId?: string }>).detail?.slotId
  if (slotId && String(slotId) === String(props.data.id)) {
    remountGen.value += 1
  }
}

onMounted(() => {
  window.addEventListener(SAME_WINDOW_REPLACE_EVENT, onSameWindowReplace)
})

onUnmounted(() => {
  window.removeEventListener(SAME_WINDOW_REPLACE_EVENT, onSameWindowReplace)
})
</script>
